
define(
    'Facets.FacetsDisplay.View.Extension',
    [
        'Facets.FacetsDisplay.View',
        'underscore',
        'Utils'
    ],
    function(
        FacetsFacetsDisplayView,
        _,
        Utils

    ) {
        'use strict';



        _.extend(FacetsFacetsDisplayView.prototype, {

            removeCatFacetsFromNarrwoBy : function(ret){
                
                try{
                    var facets = this.options.facets;
                    _.each(facets,function(facet){
                        if (facet.id.indexOf("cat_path")!= -1){
                            // remove the facet from the ret object
                         
                            ret.values = _.filter(ret.values,function(facetValueElement){
                                return facetValueElement.valueLabel!= facet.value[0]
                            })
                        }
                    })

                    ret.hasFacets = ret.values.length

                }catch(e){
                    
                }
            },

            getContext: _.wrap(FacetsFacetsDisplayView.prototype.getContext, function (fn) {
               
                
                var ret = fn.apply(this, _.toArray(arguments).slice(1));
                this.removeCatFacetsFromNarrwoBy(ret);
                
                
            
                return ret;
            }),



        });
    });
